module.exports = __webpack_public_path__ + "static/media/mpcas.90ca0f69.png";